import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  id: null,
  key: '',
  name: '',
  prompt: '',
  variables: [],
  category: '',
  is_active: true,
  created_at: '',
  updated_at: '',
  ...item,
})

export const state = () => ({
  items: [],
  item: null,
  categories: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
  setCategories(state, categories) {
    state.categories = categories
  },
}

export const getters = {
  list(state) {
    return state.items
  },
  getCategories(state) {
    return state.categories
  },
}

export const actions = {
  async fetchAll({ commit }, params = {}) {
    const response = await this.$axios.$get('admin/aiPrompts', { params })
    if (response && response.data) {
      commit('load', response.data.map(defaultItem))
    } else {
      commit('clear')
    }
    return response
  },

  async fetchOne({ commit }, id) {
    const response = await this.$axios.$get(`admin/aiPrompts/${id}`)
    if (response && response.data) {
      // We don't necessarily need to commit 'set' here if we are just fetching for edit
      // but CRUDMutations usually implies 'set' might set a 'current' item or similar,
      // but 'product.js' uses 'set' to set... wait, product.js 'set' usually replaces the list or a single item?
      // In product.js: commit('set', item.data).
      // Let's assume for now we might leave it to the component to handle the single item state or just return it.
      // However, to be consistent with product.js patterns:
      // product.js actions: getProduct -> commit('set', item.data).
      // Let's see what 'set' does in CRUDMutations.
      // Usually it might be `state.item = payload`.
      // Since I don't see CRUDMutations source, I will assume it handles a single item 'item' state or similar.
      // Wait, `state` in product.js shows `items: []`. It doesn't explicitly show `item: {}`.
      // Let's look at product.js again. It has `defaultItem`.
      // actions: getProduct calls commit('set', item.data).
      // If CRUDMutations is standard, maybe it sets `state.item`.
      // Let's assume we can just return the data for now to be safe, or check CRUDMutations if possible.
      // But I can't check util files easily without reading them. I'll read store-utilities to be sure.
      return response.data
    }
  },

  async update({ commit }, { id, payload }) {
    const response = await this.$axios.$put(`admin/aiPrompts/${id}`, payload)
    if (response && response.data) {
      commit('update', defaultItem(response.data))
    }
    return response
  },

  async create({ commit }, payload) {
    const response = await this.$axios.$post('admin/aiPrompts', payload)
    if (response && response.data) {
      commit('add', defaultItem(response.data))
    }
    return response
  },

  async test({ commit }, { id, bindings, prompt }) {
    return await this.$axios.$post(`admin/aiPrompts/${id}/test`, { bindings, prompt })
  },

  async fetchCategories({ commit }) {
    const response = await this.$axios.$get('admin/aiPrompts/categories')
    if (response && response.data) {
      commit('setCategories', response.data)
    }
    return response
  },
}
